<template>
  <div class="content-body">
    <div class="container-fluid">
      <Breadcrumb name="Withdrawal" :breadcrumb="breadcrumb"/>
      <!-- row -->
      <div class="row">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Make New Request</h4>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Account</label>
                  <div class="col-sm-9">
                    <select class="form-control" v-model="selectedValet" name="valet">
                      <option :key="valetIndex" :value="valet" v-for="(valet, valetIndex) in valetData">
                        {{ valet.currency.code }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Method</label>
                  <div class="col-sm-9">
                    <select class="form-control" v-model="selectedIndex">
                      <option :key="index" :value="index" v-for="(row, index) in list">
                        {{ row.payment_method.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <Form @submit="sendCall">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Amount</label>
                  <div class="col-sm-9">
                    <Field
                        class="form-control"
                        type="text"
                        name="amount"
                        rules="required"
                        v-model="amount"
                    />
                    <ErrorMessage name="amount"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-10">
                    <Button class="btn btn-primary" :loading="loader" >Add</Button>
                    <Button class="btn btn-dark ml-1" type="button" @click="$router.push({name:'with-drawal'})">Back</Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['methodData'],
  data() {
    return {
      list: [],
      loader: false,
      amount: '',
      userAccountId: '',
      withdrawalMethodId: '',
      selectedIndex: 0,
      breadcrumb: [
        {name: 'App'},
        {name: 'Withdrawal'},
        {name: 'Add Request'},
      ],
      selectedCurrency: null,
      selectedValet: null,
      valetData: [],
    }
  },
  mounted() {
    this.getValetData()

  },
  methods: {
    getValetData() {
      this.makeRequest('post', 'v1/get-wallet-list', {}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.valetData = responseData
            this.setSelectValetValue()
            this.sendUserWithdrawalRequest()
          }
        }

      });
    },
    setSelectValetValue() {
      this.valetData.forEach((obj) => {
        if (obj.is_default == 1) {
          this.selectedValet = obj
          this.selectedCurrency = obj
        }
      })

    },
    sendUserWithdrawalRequest() {
      this.makeRequest('post', 'v1/get-user-withdrawal-methods', {flag: 'active'}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            this.list = callResponse.response.data.data
            this.userAccountId = this.list[0].user_id
            this.withdrawalMethodId = this.list[0].id
          }
        }

      });
    },
    sendCall(){

      let data ={
        "amount": this.amount * 100,
        "userAccountId": this.selectedCurrency.id,
        "withdrawalMethodId": this.withdrawalMethodId,
      }
      this.loader = true
      this.makeRequest('post','v1/add-new-withdrawal',data).then(callResponse => {

        this.loader = false
        if(!callResponse.error){
          let code = callResponse.response.data.code;

          if(code == 200){
            this.$router.push({name: 'with-drawal', params: { tab: 2 }})
          }
        }

      });

    },
  },
  watch: {
    selectedIndex(index) {
      this.userAccountId = this.list[index].user_account_id
      this.withdrawalMethodId = this.list[index].id
    },
  }
}
</script>

